import { type ErrorLike } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';

import { hasGraphqlErrorCode } from '@/apollo/utils/hasGraphqlErrorCode';
import { isUnexpectedError } from '@/apollo/utils/isUnexpectedError';

type CreateErrorLinkArgs = {
  onUnauthenticated: () => void;
  onUnexpectedError: (error: ErrorLike) => void;
};

// Handles only what no single screen can: a signed-out answer, and unexpected
// failures nobody shows. Expected errors (NOT_FOUND, CONFLICT...) are left to
// the screen that made the request.
export const createErrorLink = ({
  onUnauthenticated,
  onUnexpectedError,
}: CreateErrorLinkArgs) =>
  new ErrorLink(({ error, operation }) => {
    if (hasGraphqlErrorCode(error, 'UNAUTHENTICATED')) {
      onUnauthenticated();
      return;
    }

    const shouldSkipErrorToast =
      operation.getContext().shouldSkipErrorToast === true;

    if (!shouldSkipErrorToast && isUnexpectedError(error)) {
      onUnexpectedError(error);
    }
  });
